import { forwardRef } from 'react';
import styles from './Checkbox2.module.scss';

const Checkbox2 = forwardRef(
  ({ checked = false, onChange, children, disabled = false, className = '', ...props }, ref) => {
    const checkboxClasses = [styles.checkbox, disabled ? styles.disabled : '', className]
      .filter(Boolean)
      .join(' ');

    const visualBoxClasses = [
      styles.visualBox,
      checked ? styles.checked : '',
      disabled ? styles.disabled : ''
    ]
      .filter(Boolean)
      .join(' ');

    const checkIconClasses = [styles.checkIcon, checked ? styles.visible : '']
      .filter(Boolean)
      .join(' ');

    return (
      <label className={checkboxClasses}>
        <input
          ref={ref}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={styles.nativeInput}
          {...props}
        />
        <div className={visualBoxClasses}>
          <svg
            className={checkIconClasses}
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 2L4.5 8L2 5.5"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        {children && <div className={styles.label}>{children}</div>}
      </label>
    );
  }
);

Checkbox2.displayName = 'Checkbox2';

export default Checkbox2;
